import { forwardRef } from 'react';
import { clsx } from '@/utils';

// 卡片属性接口
export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {}

// 卡片组件
export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={clsx('bg-white rounded-lg shadow-sm border border-gray-200', className)}
      {...props}
    />
  )
);

Card.displayName = 'Card';